export default __webpack_public_path__ + "static/media/icon_search_tag_program.8b858c53.svg";